import { Divider, Box } from "@jewlr/storybook/core"
import styled from "styled-components"

import { IS_AU, IS_CA } from "helpers/application"

import Banner from "./banner"
import BetterWayToPay from "./better-way-to-pay"
import Faq from "./faq"
import Footer from "./footer"
import HowItWorks from "./how-it-works"

const KlarnaBox = styled(Box).attrs((props) => ({
  ...props.theme.paymentPlans.klarna.klarnaBox,
}))``
const ContentBox = styled(Box).attrs((props) => ({
  px: props.theme.paymentPlans.klarna.contentBox.px,
}))``

const Klarna = () => {
  const isPayIn4 = IS_AU() || IS_CA()

  return (
    <KlarnaBox>
      <Banner />
      <ContentBox contain>
        <BetterWayToPay payIn4={isPayIn4} />
        <Divider />
        <HowItWorks payIn4={isPayIn4} />
        <Faq payIn4={isPayIn4} />
        <Divider />
        <Footer payIn4={isPayIn4} />
      </ContentBox>
    </KlarnaBox>
  )
}

export default Klarna
